import type { CobroExcepcionResponse } from '@aid/shared';

/**
 * Canonical adjustment amount of a cobro_excepcion.
 *
 * billing-domain-rules (Phase 5): the ledger writes only the `monto` column
 * (both for adjustments and reversals); the legacy `valor` column stays NULL on
 * new rows and is kept only as a fallback for pre-migration records. Consumers
 * MUST read `monto` first, exactly as the shared contract documents ("valor
 * will be removed once all consumers migrate").
 */
export function excepcionAmount(
  excepcion: Pick<CobroExcepcionResponse, 'monto' | 'valor'>,
): string | null {
  return excepcion.monto ?? excepcion.valor ?? null;
}
